import { money, fmtDateTime } from "@/lib/format";

// Revenue by payment method (summary row), gift card category, and manual payment line items.
export default function ReconByMethod({ data }) {
  if (!data?.revenue_by_method) return null;
  const gc = data.gift_cards;
  const lines = data.manual_payments || [];
  return (
    <div className="space-y-4" data-testid="recon-by-method">
      <div className="eyw-card p-5">
        <h3 className="font-serif text-lg text-[#1A242B] mb-3">Revenue by payment method</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
          {data.revenue_by_method.map((m) => (
            <div key={m.method} className="rounded-xl bg-[#F9F7F3] px-3 py-2" data-testid={`recon-rbm-${m.method}`}>
              <p className="text-[11px] text-[#8FA89B]">{m.label}{m.non_revenue ? " · non-revenue" : ""}</p>
              <p className="font-semibold text-[#1A242B]">{money(m.amount)}</p>
            </div>
          ))}
        </div>
        <div className="flex justify-between border-t border-[#E5E0D8] mt-3 pt-2 text-sm font-semibold" data-testid="recon-rbm-total">
          <span>Total revenue (all methods)</span><span>{money(data.revenue_by_method_total)}</span>
        </div>
        {data.allocation_shortfall_owed_by_enhancers > 0 && (
          <p className="text-xs text-[#B5794E] mt-2" data-testid="recon-shortfall">Fixed center amounts not covered by sales (owed by enhancers): {money(data.allocation_shortfall_owed_by_enhancers)}</p>
        )}
        <p className="text-[11px] text-[#8FA89B] mt-1">Promotional and complimentary amounts are value applied to bookings, shown separately and not counted as revenue.</p>
      </div>
      {gc && (
        <div className="eyw-card p-5" data-testid="recon-gift-cards">
          <h3 className="font-serif text-lg text-[#1A242B] mb-3">Gift cards</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
            <div><p className="text-[11px] text-[#8FA89B]">Sold</p><p className="font-semibold">{gc.sold_count} · {money(gc.sold_value)}</p></div>
            <div><p className="text-[11px] text-[#8FA89B]">Admin-issued</p><p className="font-semibold">{gc.issued_count} · {money(gc.issued_value)}</p></div>
            <div><p className="text-[11px] text-[#8FA89B]">Redeemed</p><p className="font-semibold">{money(gc.redeemed_value)}</p></div>
            <div><p className="text-[11px] text-[#8FA89B]">Outstanding liability</p><p className="font-semibold text-[#B5794E]">{money(gc.outstanding_liability)}</p></div>
          </div>
        </div>
      )}
      <div className="eyw-card p-5" data-testid="recon-manual-payments">
        <h3 className="font-serif text-lg text-[#1A242B] mb-3">POS &amp; manual payment lines</h3>
        {lines.length === 0 ? <p className="text-sm text-[#8FA89B]">No manual payments in this range.</p> : (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <tbody>{lines.map((m) => (
              <tr key={m.id} className="border-b border-[#F1EEE8]">
                <td className="py-1.5 text-xs whitespace-nowrap">{fmtDateTime(m.created_at)}</td>
                <td><span className="text-xs rounded-full bg-[#144F75]/10 text-[#144F75] px-2 py-0.5">{m.method_label}</span></td>
                <td className="text-xs">{m.ref_label}{m.gift_card_code ? ` · ${m.gift_card_code}` : ""}</td>
                <td className="text-right font-medium">{money(m.amount)}</td>
              </tr>))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
